export default __webpack_public_path__ + "static/media/image2.6e6c5385.jpg";